export const TodaysLessonsItem = ({ data }) => {
  return (
    <div
      className='dx-card dx-round'
      //color='red'
      //style={'background-color:red'}
      style={{
        backgroundColor: `${data.terem.color}`,
      }}
    >
      <h5>
        {data.date_start} / {data.time_to}
      </h5>
      <p>
        {data.tanora_torz.tanora_code} - {data.tanora_torz.tanora_descr}
      </p>
      <p>{data.terem.descr}</p>
    </div>
  );
};
